<template>
  <div class="content">
    <div class="pro-mobile">
      <menu-mobile />
    </div>
    <div class="back-row-frame">
      <div class="v-c-left">
        <div
          ref="point_type"
          class="mall-dropdown"
          :class="{ active: isActive }"
          @click.stop="toggleDropdown"
        >
          <button class="dropbtn">
            {{ $t('Bao.free_spin') }}
            <i class="dropbtn-arr" />
          </button>
          <div class="dropdown-content">
            <a @click.prevent>{{ $t('Bao.free_spin') }}</a>
          </div>
        </div>
      </div>
      <div class="v-c-right">
        <div class="exchange-amount-frame">
          <div class="token-name">
            <span>{{ $t('Bao.point_name') }}</span>
          </div>
          <div class="token-amount">
            <span>{{ mainPoint | numberFormatThird }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="view-card mall-min-h">
      <div v-if="!allProd" class="history-list-content if-no-data">
        <div class="no-data">
          <i>
            <img :src="$getThemeImagePath('no-data.png')" alt="">
          </i>
          <p>{{ $t('Bao.no_relevant_data_records') }}</p>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>
      </div>
      <div v-else class="view-card-body ticket-list">
        <div
          v-for="prod in allProd"
          :key="prod.id"
          class="ticket-frame"
          @click="showModel(prod)"
        >
          <div class="tf-left">
            <div class="bonus-cube">
              <div class="amount rew-font-xx-larger ">
                {{ prod.freeCount }}
              </div>
              <div class="unit">
                {{ $t('Bao.free_spin_unit') }}
              </div>
            </div>
          </div>
          <div class="tf-right">
            <div class="title">
              {{ prod.name }}
            </div>
            <div class="describe">
              {{ $t('Bao.point_amount', {amount: prod.amount}) }}
            </div>
            <div class="second-half">
              <div class="describe">
                <div class="des-end">
                  VIP {{ prod.vip.map(v => v.replace('VIP', '')).join('/') }}
                </div>
              </div>
              <div>
                <a v-if="prod.availBuy" class="btn btn-exchange">{{ $t('Bao.redeem') }}</a>
                <a v-else class="btn btn-exchange lock">
                  <img :src="$getThemeImagePath('icon-lock.png')" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-purchase-modal :is-active="showModal" :selected-prod="selectedProd" @hideModel="hideModel" />
    </div>
  </div>
</template>
<script>
import { detectMob, refreshGold } from '@/utils/tool'
import { showNotice } from '@/utils/tool'
import { getAllProductInfo, purchaseProd } from '@/api/shop'
import confirmPurchaseModal from '@/components/modal/confirmPurchaseModal'
import menuMobile from '@/components/shop/menuMobile'

export default {
  components: {
    confirmPurchaseModal,
    menuMobile
  },
  data() {
    return {
      allProd: [],
      showModal: false,
      selectedProd: {},
      isActive: false
    }
  },
  computed: {
    mainPoint() {
      const storeMainPoint = this.$store.getters.mainPoint
      if (!isNaN(storeMainPoint)) {
        return storeMainPoint
      } else {
        return this.$store.state.user.memberInfo.main_points
      }
    }
  },
  watch: {
    '$store.state.user.isConfirmPurchase': function(newVal) {
      if (newVal) {
        this.$store.commit('SET_SHOP_PURCHASE', false)
        showNotice(this.$t('Bao.free_spin_double_check'))
      }
    },
    '$store.state.user.isConfirmPurchaseDoubleCheck': function(newVal) {
      if (newVal && this.selectedProd.type === 4) {
        this.buyProd(this.selectedProd)
        this.$store.commit('SET_CONFIRM_PURCHASE', false)
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  created() {
    this.$store.commit('SET_CONFIRM_PURCHASE', false)
    this.$store.commit('SET_SHOP_PURCHASE', false)
    this.getAllProd()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const point_type = this.$refs.point_type
      if (this.isActive && point_type && !point_type.contains(event.target)) {
        this.isActive = false
      }
    },
    toggleDropdown() {
      this.isActive = !this.isActive
    },
    getAllProd() {
      getAllProductInfo().then((response) => {
        let allProd = []
        const play_n_go_free_play = response.data.data.data.play_n_go_free_play
        const PragmatciPlayFreeSpin = response.data.data.data.PragmatciPlayFreeSpin

        // 处理 play_n_go_free_play 的 freeCount
        const processedPlayNGo = play_n_go_free_play.map(prod => {
          return {
            ...prod,
            freeCount: prod.setting.spin_count
          }
        })

        if (PragmatciPlayFreeSpin) {
          // 处理 PragmatciPlayFreeSpin 的 freeCount
          const processedPragmaticPlay = PragmatciPlayFreeSpin.map(prod => {
            return {
              ...prod,
              freeCount: prod.setting.round
            }
          })

          allProd = [...processedPlayNGo, ...processedPragmaticPlay]
        } else {
          allProd = processedPlayNGo
        }

        const currentVipIndex = this.$store.state.user.vipInfo.currentVipName
        const currentVip = parseInt(currentVipIndex.replace('VIP', ''))
        const finalCurrentlVip = isNaN(currentVip) ? 'lite player' : currentVip

        this.allProd = allProd.map(prod => {
          const requiredVip = prod.vip
          const vipNumbers = requiredVip.map(vipQual => parseInt(vipQual.replace('VIP', '')))
          const finalVipNumbers = vipNumbers.map(num => (isNaN(num) ? 'lite player' : num))

          let vipQual = false
          finalVipNumbers.forEach(num => {
            if (finalCurrentlVip >= num) {
              vipQual = true
            }
          })
          return {
            ...prod,
            type: 4,
            availBuy: Math.floor(Number(this.mainPoint)) >= prod.amount && vipQual
          }
        })
      })
        .then(
          refreshGold()
        )
        .catch(error => {
          this.allProd = null
          showNotice(error.response.data.msg)
        })
    },
    buyProd(prod) {
      purchaseProd({ id: prod.id, sub_id: prod.sub_id }).then((response) => {
        this.handlePurchaseResponse(response.status, true)
        this.getAllProd()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    showModel(prod) {
      this.selectedProd = prod
      this.showModal = true
    },
    hideModel() {
      this.showModal = false
    },
    isMobile() {
      return detectMob()
    },
    handlePurchaseResponse(status, showNoticeFlag) {
      let message
      if (status === 200) {
        message = this.$t('Bao.purchase_success')
      } else if (status === 201) {
        message = this.$t('Bao.discrepancy_level')
      } else if (status === 202) {
        message = this.$t('Bao.sold_out')
      } else if (status === 203 || status === 204 || status === 207) {
        message = this.$t('Bao.not_enough_points')
      } else {
        message = this.$t('Bao.unavailable_1') + status + this.$t('Bao.unavailable_2')
      }

      if (showNoticeFlag) {
        showNotice(message)
      } else {
        return message
      }
    }
  }
}
</script>

<style scoped>

</style>
